import React from 'react'
import {Trans, useTranslation} from 'react-i18next'

import {BottomSheet} from 'src/designSystem/components/atoms/BottomSheet/BottomSheet'
import Box from 'src/designSystem/components/atoms/Box/Box'
import PFText from 'src/designSystem/components/atoms/PFText/PFText'

type Props = {
  showBottomSheet: boolean
  hideBottomSheet: () => void
  nextPaymentDate: string
  onHandleCancelMembership: () => Promise<void>
  onHandleKeepMembership: () => void
  isCancellingMembership: boolean
}

const CancelMembershipBottomSheet = (props: Props): JSX.Element => {
  const {
    hideBottomSheet,
    showBottomSheet,
    nextPaymentDate,
    onHandleCancelMembership,
    onHandleKeepMembership: handleKeepMembership,
    isCancellingMembership,
  } = props

  const {t} = useTranslation('CancelMembershipBottomSheet')

  const bottomSheetContent = (
    <Box gap="small">
      <PFText variant="p">{t('IfYouCancelNowYouWillNoLongerBeEligibleForAdvances')}</PFText>
      <PFText variant="p">
        <Trans
          t={t}
          i18nKey="YourFinalMembershipFeeWillBeChargedOnFeeDate"
          components={{bold: <PFText variant="p_semibold" />}}
          values={{
            nextPaymentDate,
          }}
        />
      </PFText>
    </Box>
  )

  const keepMembershipButton = {
    text: t('KeepMembership'),
    onPress: handleKeepMembership,
    testID: 'Keep-Membership-Button',
  }

  const confirmCancellationButton = {
    text: t('ConfirmCancellation'),
    onPress: onHandleCancelMembership,
    testI: 'Cancel-Membership-Button',
    iconName: 'arrowRight' as const,
    textVariantOverride: 'p_semibold' as const,
    disabled: isCancellingMembership,
  }

  return (
    <BottomSheet
      title={t('AreYouSure')}
      titleVariant="h3"
      titleAlign="left"
      testID="Cancel-Membership-BottomSheet"
      visible={showBottomSheet}
      showDots={false}
      showCloseButton
      closeButtonAction={hideBottomSheet}
      onDismiss={handleKeepMembership}
      secondaryButton={confirmCancellationButton}
      dismissButton={keepMembershipButton}
    >
      {bottomSheetContent}
    </BottomSheet>
  )
}

export {CancelMembershipBottomSheet}
